
<div class="">
    <div class="container-fluid shipment-details" style="height: 100vh;">
      <div class="row">
        <div class="col doc-header">
          Shipment details
        </div>
        <div class="col-auto ml-auto doc-header">
          ID: {{shipmentDetails.id}}
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Status:
          </div>
          <div class="value">
            {{shipmentDetails.status}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Location:
          </div>
          <div class="value" style="line-break: anywhere; overflow: initial; white-space: initial; ">
            {{shipmentDetails.location}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Date of creation:
          </div>
          <div class="value" *ngIf="shipmentDetails.dateOfCreation">
            {{shipmentDetails.dateOfCreation|date:'dd/MM/yyyy'}}
          </div>
          <div class="value" *ngIf="!shipmentDetails.dateOfCreation">
            -
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            To:
          </div>
          <div class="value" style="line-break: anywhere; overflow: initial; white-space: initial; ">
            {{shipmentDetails.shipmentTo}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Courier name:
          </div>
          <div class="value">
            {{shipmentDetails.courierName}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Tracking number:
          </div>
          <div class="value">
            {{shipmentDetails.trackingNo}}
          </div>
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-12">
          <table class="table inner-table">
            <thead>
              <tr>
                <th scope="col">Sample type</th>
                <th scope="col">Quantity</th>
                <th scope="col">Sample IDs</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="shipmentDetails.details">
                <tr *ngFor="let task of shipmentDetails.details">
                  <td>{{task.sampleType}}</td>
                  <td>{{task.quantity}}</td>
                  <td class="td-width">{{task.sampleIds}}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="!shipmentDetails.details || 
              (shipmentDetails.details && 
              shipmentDetails.details.length == 0)">
                <tr >
                  <td colspan="3" style="text-align: center;">There are no sample available</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>